/**
 * Use values of 53 bits since JS supports precision only for 53 Significand bits or digits according to IEEE 754 standard
 *
 * @see https://eslint.org/docs/latest/rules/no-loss-of-precision
 * @see https://en.wikipedia.org/wiki/IEEE_754#Basic_and_interchange_formats
 */
export const maxIntValue = parseInt('1'.repeat(53), 2); // 9007199254740991
